import { Cube, CheckSquare, Square } from "@phosphor-icons/react";
import { PickerItemProps } from "../../types";

interface UnitData {
  id: string;
  unitType?: string;
}

interface UnitItemProps extends PickerItemProps<UnitData> {
  showCheckbox?: boolean;
}

export const UnitItem = ({ item, isSelected, onSelect, showCheckbox }: UnitItemProps) => {
  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-3 py-2 rounded-md text-sm transition-colors hover:bg-brick-secondary-fine ${
        isSelected ? "bg-moss-primary/10 border border-moss-primary/30" : ""
      }`}
    >
      <div className="flex items-center gap-2">
        {showCheckbox && (
          isSelected ? (
            <CheckSquare className="h-4 w-4 text-moss-primary" weight="fill" />
          ) : (
            <Square className="h-4 w-4 text-neutral-secondary-mid" />
          )
        )}
        <Cube className="h-4 w-4 text-neutral-secondary-mid" />
        <div>
          <div className="font-medium text-neutral-primary">{item.id}</div>
          {item.unitType && (
            <div className="text-xs text-neutral-secondary-mid">{item.unitType}</div>
          )}
        </div>
      </div>
    </button>
  );
};